import React from "react";

type Props = {};
type State = {};
export class Admin404NotFound extends React.Component<Props, State> {
	render() {
		return (
			<div style={{textAlign: "center"}}>
				<h2>Admin 404 Not found!</h2>
			</div>
		);
	}
}